import { render } from "./ActivityDetails.vue?vue&type=template&id=48d3f32a&scoped=true"
import script from "./ActivityDetails.vue?vue&type=script&lang=js"
export * from "./ActivityDetails.vue?vue&type=script&lang=js"

import "./ActivityDetails.vue?vue&type=style&index=0&id=48d3f32a&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src338202144/src/web-app-vue-3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48d3f32a"]])

export default __exports__